<template>
  <button
    :type="type"
    class="submit-button"
    :class="[design !== '' ? 'submit-button--' + design : '']"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <span class="submit-button__text">{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: "SubmitButton",
  props: {
    type: {
      type: String,
      default: 'button'
    },
    text: {
      type: String,
      default: '次へ'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    design: {
      type: String,
      default: ''
    },
  }
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.submit-button {
  $root: &;
  appearance: none;
  position: relative;
  width: 100%;
  height: 55px;
  background: none;
  border-radius: 35px;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  border: none;
  transition: 0.2s;
  outline: none;
  &__text {
    position: relative;
    z-index: 3;
    color: mix($col_temp_key1, $col_temp_key2);
    font-weight: 600;
    font-size: 14px;
    line-height: 1;
    background: $col_def_gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 35px;
    pointer-events: none;
  }
  &::before {
    margin: 2px;
    background: $col_white;
    z-index: 2;
  }
  &::after {
    background: $col_def_gradient;
    z-index: 1;
  }
  &:disabled {
    &::after {
      background: $col_temp_gray3;
    }
    #{$root}__text {
      color: $col_temp_gray3;
      background: none;
      -webkit-text-fill-color: initial;
    }
  }
  // design === fill
  &--fill {
    &::before {
      display: none;
    }
    #{$root}__text {
      color: #fff;
      -webkit-text-fill-color: initial;
    }
    &:disabled {
      #{$root}__text {
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/SubmitButton.vue